import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { environment } from 'environments/environment';
import html2canvas from 'html2canvas';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import QRCode from 'qrcode';

@Component({
  selector: 'app-event-list-table',
  templateUrl: './event-list-table.component.html',
  styleUrl: './event-list-table.component.scss'
})
export class EventListTableComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  eventDetails: EventBookingDetails[] = [];
  filteredEvents: EventBookingDetails[] = [];
  searchText: any = "";
  eventDate: string = "";
  eventVenue: string = "";
  qrCodeValue : string = "";
  qrCodeUrl: string = '';
uniqueCities: string[] = [];
selectedCity: string = "";

  constructor(
    private appService: AppService, private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit(): void {
    this.eventDetailsGetAll();
  }

  eventDetailsGetAll() {
      this.spinner.show();
      this.appService.eventDetailsGetAll()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          const today = new Date().setHours(0, 0, 0, 0);
          const sorted = data
            .sort((a, b) => {
              const aIsFuture = a.startDate >= today;
              const bIsFuture = b.startDate >= today;
              if (aIsFuture && !bIsFuture) return -1;
              if (!aIsFuture && bIsFuture) return 1;
              return a.startDate - b.startDate;
            });
          this.eventDetails = sorted;
          this.uniqueCities = [...new Set(data.map(x => x.city).filter(x => x))];
          this.filteredEvents = [...this.eventDetails];

          this.spinner.hide();
        }, (error: any) => {
          this.spinner.hide()
          this.toastr.error(error?.error?.message || "Something Went Wrong, Please Try Again")
        });
    }

    applyFilters() {
  let data = [...this.eventDetails];

  // City filter
  if (this.selectedCity) {
    data = data.filter(ev => ev.city === this.selectedCity);
  }

  // Search filter
  if (this.searchText.trim()) {
    const s = this.searchText.toLowerCase();
    data = data.filter(ev =>
      ev.eventName?.toLowerCase().includes(s) ||
      ev.city?.toLowerCase().includes(s)
    );
  }

  this.filteredEvents = data;
}


getEventLink(eventId: string) {
  return environment.baseUrl + eventId;
}

encodeEventId(id: number | null | undefined): string {
  if (!id) return '';
  return btoa(id.toString()); 
}


onEdit (id: number | null | undefined): any {
  const eventId = btoa(id.toString());
  localStorage.setItem('eventId',eventId)
  this.router.navigate(['/main/event-creation']);
}

showPopUp(value : any){
  this.eventDate = value.eventDate;
  this.eventVenue= value.eventVenue;
  this.qrCodeValue = this.getEventLink(this.encodeEventId(value?.eventId));
  this.generateQRCode(this.qrCodeValue);
}


  ngAfterViewInit() {
    const modal = document.getElementById('exampleModal');
    modal?.addEventListener('shown.bs.modal', async () => {
      // Generate QR code when modal opens
      this.qrCodeUrl = await this.generateQRCode(this.qrCodeValue);
    });
  }

  generateQRCode(ticketNo: string): Promise<string> {
    return QRCode.toDataURL(ticketNo, {
      color: {
        dark: '#ffff', // black modules
        light: '#0000'   // transparent background
      },
    });
  }

  isEventActive(endDate: number): boolean {
  const now = Date.now(); // current epoch
  return endDate > now;   // active only if endDate is greater
}


downloadModalAsImage() {
  const element = document.querySelector('.modal-bg-wrapper') as HTMLElement;
  if (!element) return;

  // Show spinner
  this.spinner.show();

  const images = Array.from(element.getElementsByTagName('img'));

  const imagePromises = images.map(img => {
    if (img.complete) return Promise.resolve();
    return new Promise<void>(resolve => {
      img.onload = () => resolve();
      img.onerror = () => resolve(); // still proceed even if image fails
    });
  });

  Promise.all(imagePromises)
    .then(() => {
      return html2canvas(element, {
        scale: 2,
        backgroundColor: null,
        useCORS: true
      });
    })
    .then(canvas => {
      const link = document.createElement('a');
      link.download = 'Velmaral_Event.png';
      link.href = canvas.toDataURL('image/png');
      link.click();

      // Hide spinner + Success message
      this.spinner.hide();
      this.toastr.success('Image downloaded successfully!', 'Success');
    })
    .catch(err => {
      // Hide spinner + Error message
      this.spinner.hide();
      this.toastr.error('Failed to download image. Please try again.', 'Error');
      console.error('Download Error:', err);
    });
}
async directDownload(event: any) {
  this.spinner.show();

  this.eventDate = event.eventDate;
  this.eventVenue = event.city;

  const qrValue = this.getEventLink((event?.city));
  this.qrCodeUrl = await this.generateQRCode(qrValue);

  setTimeout(async () => {

    const qrImg = document.getElementById('hiddenQrImg') as HTMLImageElement;

    await new Promise<void>((resolve) => {
      if (!qrImg) return resolve();
      if (qrImg.complete) resolve();
      qrImg.onload = () => resolve();
      qrImg.onerror = () => resolve();
    });

    const element = document.querySelector('#hidden-download-wrapper .modal-bg-wrapper') as HTMLElement;

    html2canvas(element, {
      scale: 3,
      useCORS: true,
      backgroundColor: null
    })
      .then(canvas => {
        const link = document.createElement('a');
        link.download = 'Velmaral_Event.png';
        link.href = canvas.toDataURL('image/png');
        link.click();

        this.spinner.hide();
        this.toastr.success("Downloaded successfully!");
      })
      .catch(err => {
        console.error(err);
        this.spinner.hide();
        this.toastr.error("Error capturing image");
      });

  }, 200);
}



}
